import { useTranslation } from 'react-i18next'
import TexturingConfigTable from './TexturingConfigTable'
import PropTypes from 'prop-types'

const StepTwoTexturingConfig = (props) => {
  const { t } = useTranslation()

  return (
    <>
      <h2 style={{ margin: '50px 0' }}>{t('service.apply_texturing.title')}</h2>
      <TexturingConfigTable
        bookableParts={props.bookableParts}
        setCurrentFormValues={props.setCurrentFormValues}
        setConfigState={props.setConfigState}
        rowDataRef={props.rowDataRef}
      />
      <div style={{ marginTop: '20px' }}></div>
    </>
  )
}

StepTwoTexturingConfig.propTypes = {
  bookableParts: PropTypes.shape({
    bookableParts: PropTypes.array.isRequired,
  }),
  setCurrentFormValues: PropTypes.func.isRequired,
  setConfigState: PropTypes.func.isRequired,
  rowDataRef: PropTypes.object.isRequired,
}

export default StepTwoTexturingConfig
